const indexItems = [
  { title: '都市言情', count: '128部', desc: '甜蜜恋爱与虐心纠葛', icon: 'ri-heart-line', color: 'bg-accent-100', iconColor: 'text-accent-600' },
  { title: '奇幻冒险', count: '96部', desc: '异世界与史诗征程', icon: 'ri-sword-line', color: 'bg-primary-100', iconColor: 'text-primary-600' },
  { title: '悬疑推理', count: '73部', desc: '烧脑谜题层层揭开', icon: 'ri-search-eye-line', color: 'bg-secondary-200', iconColor: 'text-secondary-700' },
  { title: '科幻巨制', count: '54部', desc: '未来世界与科技畅想', icon: 'ri-rocket-line', color: 'bg-primary-100', iconColor: 'text-primary-600' },
  { title: '热血战斗', count: '87部', desc: '燃爆全场的格斗对决', icon: 'ri-fire-line', color: 'bg-accent-100', iconColor: 'text-accent-600' },
  { title: '浪漫喜剧', count: '65部', desc: '轻松治愈的日常笑料', icon: 'ri-emotion-happy-line', color: 'bg-secondary-200', iconColor: 'text-secondary-700' },
  { title: '修仙玄幻', count: '42部', desc: '国漫原创修炼之路', icon: 'ri-moon-clear-line', color: 'bg-primary-100', iconColor: 'text-primary-600' },
  { title: '恐怖惊悚', count: '31部', desc: '惊险刺激的悬疑体验', icon: 'ri-ghost-line', color: 'bg-accent-100', iconColor: 'text-accent-600' },
  { title: '完结推荐', count: '210部', desc: '已完结高分神作合集', icon: 'ri-check-double-line', color: 'bg-secondary-200', iconColor: 'text-secondary-700' },
];

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            追更索引
          </h2>
          <p className="text-foreground-600 text-sm max-w-xl mx-auto">
            按题材分类浏览，快速找到你感兴趣的连载漫画
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 max-w-5xl mx-auto">
          {indexItems.map((item, idx) => (
            <a
              key={idx}
              href="#topics"
              className="group flex items-center gap-4 p-4 bg-background-50 rounded-xl border border-background-200/70 transition-all duration-300 hover:-translate-y-1 cursor-pointer"
            >
              <div className={`w-12 h-12 flex items-center justify-center rounded-xl ${item.color} flex-shrink-0`}>
                <i className={`${item.icon} text-xl ${item.iconColor}`}></i>
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2">
                  <h3 className="font-heading text-sm font-bold text-foreground-900">{item.title}</h3>
                  <span className="text-xs text-foreground-500 font-medium">{item.count}</span>
                </div>
                <p className="text-xs text-foreground-600 mt-0.5">{item.desc}</p>
              </div>
              <div className="flex-shrink-0 opacity-0 group-hover:opacity-100 transition-opacity">
                <i className="ri-arrow-right-line text-foreground-400"></i>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}